module.exports = __webpack_public_path__ + "img/5.0efc8b4d.gif";